export enum OpportunityStatus {
  Open = 'open',
  Closed = 'closed',
}

export enum OpportunityCandidateStatus {
  New = 'new',
  Offered = 'offered',
  Archived = 'archived',
}
